import { makeStyles } from "@fluentui/react-components";

export const useStyle = makeStyles({
	container: {
        backgroundColor: "#ffffff",
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    containerDark: {
        backgroundColor: "rgb(61, 61, 61)"
    },
    errorText: {
        textAlign: "center"
    },
    errorTextDark: {
        color: "#ffffff"
    }
});
